import React from 'react';
import AboutCard from './aboutCard';
import { faRocket, faMugHot, faBox } from '@fortawesome/free-solid-svg-icons'
import * as Styles from "./about.css";

const AboutSection = (props) => {
    const data = [
        {
            icon: faRocket,
            title: 'Lorem Ipsium',
            body: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut'
        },
        {
            icon: faMugHot,
            title: 'Lorem Ipsium',
            body: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut'
        },
        {
            icon: faBox,
            title: 'Lorem Ipsium',
            body: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut'
        }
    ]
    return (
        <Styles.AboutWrapper>
            <Styles.AboutHeadr>
                Lorem Ipsium Now?
            </Styles.AboutHeadr>
            <div className="container mt-5">
                <div className="columns">
                    {data.map((item, index) => {
                        return (
                            <div className="column is-one-third" key={index}>
                                <AboutCard icon={item.icon} title={item.title} body={item.body} />
                            </div>
                        )
                    })}
                </div>
            </div>
        </Styles.AboutWrapper>
    );
}

export default AboutSection;